import React, {Component} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import css from './PhotoPack.module.scss';
import InstallPhotoPack from "./InstallPhotoPack";
import ElectricalPhotoPack from "./ElectricalPhotoPack";
import BatteryPhotoPack from "./BatteryPhotoPack";
import MPUPhotoPack from "./MPUPhotoPack";
import MiscElectricalPhotoPack from "./MiscElectricalPhotoPack";
import ServiceCallPhotoPack from "./ServiceCallPhotoPack";
import InspectionPhotoPack from "./InspectionPhotoPack";
import SiteSurveyPhotoPack from "./SiteSurveyPhotoPack";
import SafetyAuditPhotoPack from "./SafetyAuditPhotoPack";

/**
 * @class
 *
 * PhotoPack page.
 */
const PhotoPack = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.match.params.id;
    sessId = this.props.match.params.sessId;
    type = this.props.match.params.type;

    // ---------- life cycle methods: ----------
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    render() {
        return (
            <div className={css.PhotoPack}>
                {
                    this.type === 'install' ? 
                    <InstallPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'electrical' ? 
                    <ElectricalPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'mpu' ? 
                    <MPUPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'miscElectrical' ? 
                    <MiscElectricalPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'battery' ?
                    <BatteryPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'serviceCall' ?
                    <ServiceCallPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'inspection' ?
                    <InspectionPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'siteSurvey' ?
                    <SiteSurveyPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    this.type === 'safetyAudit' ?
                    <SafetyAuditPhotoPack opportunityId={this.opportunityId} sessId={this.sessId} type={this.type} />
                    :
                    <></>
                }
            </div>
        )
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(PhotoPack);